import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
import { DropMenuPaneEl } from "common/components/drop-menu-pane";
import { ButtonBarEl } from "common/components/button-bar";
import { ButtonEl } from "common/components/button";
import { SvgIconEl } from "common/components/svg-icon";
import { ButtonTheme } from "common/components/button/constants";
import { DropMenuEl } from "common/components/drop-menu";
import { TooltipEl } from "common/components/tooltip";
import { DateRangePickerEl } from "common/widgets/date-range-picker";
import { LiftType } from "common/report/util/lift/types";
import { MenuDropdownState } from "common/widgets/lift-comparison-menu/types";
import { Visibility } from "common/components/base/stackable";
import { LiftBaselineMenuEl } from "common/widgets/lift-comparison-menu/lift-baseline-menu";
import { SpinnerEl } from "common/components/spinner";
import { SpinnerSize } from "common/components/spinner/types";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { DisplaySize, Placement } from "common/components/tooltip/types";
import compareSvg from "common/assets/images/charts/compare.svg";
function MenuOptions({ sections, onClick }) {
  return /* @__PURE__ */ jsx("div", {
    sel: ".time-comparison-options"
  }, /* @__PURE__ */ jsx(ItemsMenuEl, {
    attrs: {
      sections
    },
    on: { clickItem: onClick }
  }));
}
function CustomDateComparisonMenu({ pickerOptions, onChangeDate, onApply, onBack }) {
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(DropMenuPaneEl, {
    sel: ".mp-time-comparison-selector-menu",
    attrs: {
      header: `Compare to Date`,
      "show-back-button": true
    },
    style: { overflow: `visible` },
    on: { "back-click": onBack }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-query-datepicker-container"
  }, /* @__PURE__ */ jsx(DateRangePickerEl, {
    attrs: pickerOptions,
    on: {
      changeDateRange: onChangeDate
    }
  }))), /* @__PURE__ */ jsx(ButtonBarEl, {
    sel: ".mp-button-bar-primary",
    attrs: {
      tabindex: 0
    },
    on: { click: onApply }
  }, "Apply"));
}
function BaselineComparison({
  segment,
  breakdowns,
  onApply,
  onBack
}) {
  if (!breakdowns.length) {
    return /* @__PURE__ */ jsx("div", {
      sel: ".spinner-container"
    }, /* @__PURE__ */ jsx(SpinnerEl, {
      attrs: { size: SpinnerSize.Large }
    }));
  }
  return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(DropMenuPaneEl, {
    sel: ".mp-time-comparison-selector-menu",
    attrs: {
      header: `Select Baseline`,
      "show-back-button": true
    },
    style: { overflow: `visible` },
    on: { "back-click": onBack }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".baseline-container"
  }, /* @__PURE__ */ jsx(LiftBaselineMenuEl, {
    attrs: {
      "baseline-options": breakdowns,
      segment
    },
    on: {
      select: (ev) => onApply(ev)
    }
  }))));
}
export function template() {
  var _a;
  let menuBody;
  switch (this.state.dropdownState) {
    case MenuDropdownState.CustomTime:
      menuBody = /* @__PURE__ */ jsx(CustomDateComparisonMenu, {
        onBack: () => this.onPaneBackClick(),
        onApply: () => this.applyDateRange(),
        pickerOptions: this.getDateRangePickerOptions(),
        onChangeDate: (ev) => this.changedDateRange(ev)
      });
      break;
    case MenuDropdownState.Baseline:
      menuBody = /* @__PURE__ */ jsx(BaselineComparison, {
        segment: this.getSegmentNameAndLabel().segmentLabel,
        breakdowns: this.attr(`selected-breakdown-segments`),
        onBack: () => this.onPaneBackClick(),
        onApply: (ev) => this.applyBaseline(ev)
      });
      break;
    case MenuDropdownState.List:
      menuBody = /* @__PURE__ */ jsx(MenuOptions, {
        sections: this.getSections(),
        onClick: (ev) => this.onPresetMenuClick(ev)
      });
      break;
  }
  let buttonExtra = null;
  if (this.attr(`selected-date`) || this.attr(`selected-lift-comparison`)) {
    buttonExtra = /* @__PURE__ */ jsx("div", {
      sel: ".remove-button",
      on: { click: (ev) => this.handleRemove(ev) }
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `circle-clear` }
    }));
  } else {
    buttonExtra = /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `caret-down` }
    });
  }
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-lift-comparison-menu"
  }, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      pressed: this.state.isMenuOpen,
      elref: `compareButton`
    },
    on: {
      click: () => this.update({ isMenuOpen: !this.state.isMenuOpen })
    }
  }, /* @__PURE__ */ jsx("span", {
    sel: ".lift-label"
  }, /* @__PURE__ */ jsx("span", {
    sel: ".label-prefix"
  }, this.selectedLabel()), buttonExtra)), !this.state.isMenuOpen && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: {
      placement: Placement.Top,
      "image-src": compareSvg,
      size: DisplaySize.Small
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".info-tooltip"
  }, "Compare change over time using segments as baselines.", ` `, /* @__PURE__ */ jsx("a", {
    attrs: { href: `https://help.mixpanel.com/hc/en-us/articles/4485419360916`, target: `_blank` }
  }, "Learn more."))), /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: { open: this.state.isMenuOpen },
    on: {
      change: (ev) => this.update({ isMenuOpen: Visibility.Open === ev.detail.state, dropdownState: MenuDropdownState.List })
    }
  }, menuBody), this.isLiftToggleAvailable() && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ToggleEl, {
    attrs: {
      theme: ToggleTheme.SegmentedController,
      selected: ((_a = this.attr(`selected-lift-comparison`)) == null ? void 0 : _a.type) === LiftType.Time ? `lift` : `absolute`,
      options: this.liftToggleOptions()
    },
    on: {
      select: (ev) => this.handleLiftToggle(ev)
    }
  })));
}
